<div class="modal-backdrop" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="onClose()" aria-label="Schließen">
      <span>&times;</span>
    </button>
    
    <div class="modal-header">
      <h2>{{ planDetail().name }}</h2>
      <div class="price-display">
        @if (planDetail().originalPrice && planDetail().savedAmount) {
          <span class="original-price">{{ formatPrice(planDetail().originalPrice!) }}€</span>
        }
        <span class="current-price">{{ formatPrice(planDetail().priceEUR) }}€</span>
        @if (planDetail().durationMonths && planDetail().durationMonths! > 0) {
          <span class="duration">/ {{ planDetail().durationMonths }} Monat{{ planDetail().durationMonths! > 1 ? 'e' : '' }}</span>
        } @else if (planDetail().durationHours && planDetail().durationHours! > 0) {
          <span class="duration">/ {{ planDetail().durationHours }}h</span>
        }
      </div>
      @if (planDetail().discountPercent > 0) {
        <div class="discount-badge">{{ planDetail().discountPercent }}% Rabatt</div>
      }
    </div>

    <div class="modal-body">
      <p class="detailed-description">{{ planDetail().detailedDescription }}</p>

      @if (planDetail().highlightFeatures.length > 0) {
        <div class="features-section">
          <h3>Enthaltene Features:</h3>
          <ul class="features-list">
            @for (feature of planDetail().highlightFeatures; track feature) {
              <li>
                @if (feature.available) {
                  <span class="feature-icon yes">✓</span>
                } @else {
                  <span class="feature-icon no">✗</span>
                }
                {{ feature.text }}
              </li>
            }
          </ul>
        </div>
      }

      @if (planDetail().savedAmount) {
        <div class="savings-highlight">
          <strong>Sie sparen {{ formatPrice(planDetail().savedAmount!) }}€</strong>
        </div>
      }

      @if (!planDetail().autoRenew) {
        <div class="auto-renew-info">
          <span class="info-icon">ℹ️</span>
          Keine automatische Verlängerung - Sie behalten volle Kontrolle
        </div>
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">
        Zurück
      </button>
      <button class="btn btn-primary" (click)="onSelectPlan()">
        @if (planDetail().planKey === 'trial') {
          Jetzt kostenlos testen
        } @else {
          Jetzt auswählen
        }
      </button>
    </div>
  </div>
</div>
